// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-table[data-v-3384f534] {\n  padding-left: 50px;\n}\n.red[data-v-3384f534] {\n  color: #F66046;\n}\n", ""]);
// Exports
module.exports = exports;
